// extracted by mini-css-extract-plugin
export default {"carouselContainer":"Carousel_carouselContainer__o+2Pa","btnPrev":"Carousel_btnPrev__0oTXj","btnNext":"Carousel_btnNext__hIE9k"};